import { useNavigate, useSearchParams } from 'react-router-dom';
import { useCreateCategory, useTranslation } from '@/hooks';
import { CreateCategoryRequest } from '@/types/model';
import CategoryForm from '@/components/forms/CategoryForm';
import { categoryTypes } from '@/constants';
import { CategoryType } from '@/types';
import toast from 'react-hot-toast';

const CreateCategory = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const createCategoryMutation = useCreateCategory();
  const queryType = searchParams.get('type');
  const lockedType: CategoryType = categoryTypes.includes(queryType as CategoryType)
    ? (queryType as CategoryType)
    : 'MOVIE';

  const handleSuccess = async (data: CreateCategoryRequest) => {
    try {
      await createCategoryMutation.mutateAsync(data);
      toast.success(t.categories.messages.created);
      navigate(-1);
    } catch (error) {
      toast.error(error instanceof Error ? error.message : t.errors.unexpectedError);
      throw error;
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <CategoryForm
          onSuccess={handleSuccess}
          onCancel={handleCancel}
          lockedType={lockedType}
          isSubmitting={createCategoryMutation.isPending}
        />
      </div>
    </div>
  );
};

export default CreateCategory;
